import { render, staticRenderFns } from "./SmdKpiCard.vue?vue&type=template&id=20d6d628&"
import script from "./SmdKpiCard.vue?vue&type=script&lang=js&"
export * from "./SmdKpiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports